module.exports = __webpack_public_path__ + "img/app_icon.de9d4b40.png";